<div class="not-found-wrapper">
    <div class="not-found-card">
        <h1>¡Ups! No hemos podido cargar esta pantalla</h1>
        <p>
            Puede que el enlace no exista, haya caducado o se haya producido un error temporal.
        </p>
        <button type="button" class="btn-login primary" (click)="goToLogin()">
            Ir al login
        </button>
    </div>
</div>
